import { SidebarMenuItem } from './SidebarMenuItem';
import {
    MdCampaign,
    MdSettings,
} from 'react-icons/md';

import { LuLayoutDashboard } from 'react-icons/lu';
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { IoDocumentText } from "react-icons/io5";

export default function PartnerSidebar({ activeItem, setActiveItem, selectedTab, setSelectedTab }) {

    const menuItems = [
        {
            id: 'dashboard',
            title: 'Dashboard',
            url: '/',
            icon: LuLayoutDashboard,
        },
        {
            id: 'campaigns',
            title: 'Campaigns',
            url: '/campaigns',
            icon: MdCampaign,
            subItems: [
                {
                    id: 'active-campaigns',
                    label: 'Active Campaign',
                    url: '/active',
                },
                {
                    id: 'past-campaigns',
                    label: 'Past Campaigns',
                    url: '/past',
                },
                {
                    id: 'new-campaign-req',
                    label: 'New Campaign Req',
                    url: '/new-req',
                },
                {
                    id: 'modification-req',
                    label: 'Modification Req',
                    url: '/mod-req',
                },
            ]
        },
        {
            id: 'documents',
            title: 'Document Repository',
            url: '/documents',
            icon: IoDocumentText,
        },
        {
            id: 'support-section',
            isHeader: true,
            title: 'SUPPORT',
        },
        {
            id: 'support',
            title: 'Contact Support',
            url: '/support',
            icon: TfiHeadphoneAlt,
        },
        {
            id: 'settings-section',
            isHeader: true,
            title: 'SETTINGS & PROFILE',
        },
        {
            id: 'settings',
            title: 'Settings & Profile',
            url: '/settings/profile',
            icon: MdSettings,
        },
    ];

    const handleSelect = (itemId) => {
        setActiveItem(itemId);
    };

    return (
        <nav className="bg-white border-r border-gray-200 fixed left-0 top-0 h-screen no-scrollbar transition-all duration-300 z-40 w-64 flex flex-col">
                <div className="flex items-center justify-between p-4 px-3 border-b border-gray-100">
                    <div className="flex items-center space-x-1">
                        <img src={require('../../utils/media/logo.png')} alt="climate crusaders" className='h-10' />
                        <h1 className='text-green-600 font-bold'>Climate Crusaders</h1>
                    </div>
                </div>
                <div className="flex-1 overflow-y-auto py-4 no-scrollbar">
                    <nav className="space-y-1 px-3">
                        {menuItems.map((item) => {
                            // Render section headers
                            if (item.isHeader) {
                                return (
                                    <div key={item.id} className="mt-8 border-t border-gray-100 pt-4 text-sm">
                                        <h3 className="px-6 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
                                            {item.title}
                                        </h3>
                                    </div>
                                );
                            }

                            // Render menu items
                            return (
                                <SidebarMenuItem
                                    key={item.id}
                                    item={item}
                                    isActive={activeItem === item.id}
                                    onSelect={handleSelect}
                                    selectedTab={selectedTab}
                                    setSelectedTab={setSelectedTab}
                                />
                            );
                        })}
                    </nav>
                </div>
        </nav>
    );
}
